import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=6f0c309d&scoped=true&"
import script from "./ConfirmButton.vue?vue&type=script&lang=ts&"
export * from "./ConfirmButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c309d",
  null
  
)

export default component.exports